<template>
       <span>
           <tippani-header :subject="'Application for' +data.type +'Certification' "></tippani-header>
           <p>
               I would like to request you to certify my {{data.type}}. Documents related to my travel is attached here with. Other Details are as follows:

           </p>
           <div>
                  <table style="width: 100%;">
                <tr>
                    <td>Submission Id:</td>
                    <td>{{data.submission_no}}</td>
                </tr>

                <tr>
                    <td>Full name</td>
                    <td>{{data.traveller.name}}</td>
                </tr>
                <tr>
                    <td>Passport Number:</td>
                    <td>{{data.document.number}}</td>
                </tr>
                <tr>
                    <td>Certification cost ($):</td>
                    <td>
                        {{data.cost}}
                    </td>
                </tr>
                <tr v-if="data.voucher_number">
                    <td>Voucher number:</td>
                    <td>
                        {{data.voucher_number}}
                    </td>
                </tr>
            </table>
           </div>
           <div v-html="content"></div>
       <div style="margin-top: 20px;">
            Prepared by : <b>{{created_by}} </b>
        </div>
    </span>
</template>

<script>
    import TippaniHeader from "./TippaniHeader";

    export default {
        name: "NonVisaCertificationTippaniPrint",
        computed: {
            content() {
                if (this.$store.state.NonVisaCertification.certificationData.tippani_content)
                    return this.$store.state.NonVisaCertification.certificationData.tippani_content;

              return this.$store.state.NonVisaCertification.tippani_content;
            },
            data() {
                return this.$store.state.NonVisaCertification.certificationData;
            },
            created_by() {
                let roles = this.$store.state.AuthUser.user.roles;
                roles = roles[0];
                return this.$store.state.AuthUser.user.full_name + ' (' + roles.display_name + ')';
            }
        },
        components: {
            TippaniHeader
        }
    }
</script>

<style scoped>
    table, th, td {
        border: 1px solid black;
    }

    table {
        border-collapse: separate;
        border-spacing: 1px;
        border-left: 0;
        border-bottom: 0;
    }

    td, th {
        border-top: 0;
        border-right: 0;
        padding: 5px;
    }

    .td-font-bold {
        font-weight: bold;
    }
</style>
